const placeholderLabelOverrides = {
    "E-mail": "email",
    Email: "email",
    Segmentos: "segmento",
}

const normalizePlaceholderLabel = (label) => {
    const normalizedLabel = String(label || "Nome").trim()
    return placeholderLabelOverrides[normalizedLabel] || normalizedLabel.toLocaleLowerCase("pt-BR")
}

export const getFilterInputPlaceholder = (filterModel = { items: [] }, columns = []) => {
    const currentFilter = (filterModel.items || []).find((item) => item?.columnField || item?.field)
    const currentField = currentFilter?.columnField || currentFilter?.field || "name"
    return getFilterInputPlaceholderByField(currentField, columns)
}

export const getFilterInputPlaceholderByField = (field = "name", columns = []) => {
    const currentField = field || "name"
    const currentColumn = columns.find((column) => column.field === currentField)
    const filterLabel = normalizePlaceholderLabel(currentColumn?.headerName || "Nome")

    return `Digite um ${filterLabel} para filtrar`
}
